export default "__VITE_ASSET__T$IKA7bT__"